export class branch {
    id:number;
    branchname :string;
    streamid:number;
    universityid :number=1;
    }